module.exports = __webpack_public_path__ + "img/commandeSection2.4bccebfa.png";